import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Modal } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons'

import Box from '~/core/Box'
import Text from '~/core/Text'
import getColor from '~/lib/getColor'
import { ADMIN_PATH, TEAM_PATH } from '~/redux-modules/preferences'

interface ConfirmMoveQuoteOrderSuccessModalPropsType {
    id: string
    name: string
    team: { id?: string; name?: string }
    typeName: 'Quote' | 'SalesOrder'
    visible: boolean
    onCancel: () => void
}

export const ConfirmMoveQuoteOrderSuccessModal = (
    props: ConfirmMoveQuoteOrderSuccessModalPropsType,
) => {
    const { onCancel, id, name, team, visible, typeName } = props

    const { userId } = useParams<{ userId?: string }>()

    const navigate = useNavigate()
    const location = useLocation()

    const isQuote = typeName === 'Quote'
    const quoteOrOrder = isQuote ? 'quote' : 'order'

    const onOk = () => {
        const path = location.pathname.includes(ADMIN_PATH)
            ? `${ADMIN_PATH}/user/${userId}/team/${team.id}/${quoteOrOrder}s/${
                  isQuote ? id : name
              }`
            : `${TEAM_PATH}/${team.id}/${quoteOrOrder}s/${isQuote ? id : name}`

        navigate(path)
    }

    return (
        <Modal
            maskClosable
            onCancel={onCancel}
            onOk={onOk}
            okText={`View in workspace`}
            visible={visible}
            width="630px"
            cancelText="Close"
        >
            <Box>
                <Box>
                    <CheckCircleOutlined
                        style={{
                            color: getColor('success'),
                            fontSize: '23px',
                            marginRight: '18px',
                        }}
                    />
                </Box>
                <Box direction="col">
                    <Text fontSize="16px" fontWeight={400}>
                        {name} successfully added to {team.name}
                    </Text>
                    <Text style={{ marginTop: '12px' }}>
                        Members of the team now have access to this{' '}
                        {quoteOrOrder}
                    </Text>
                </Box>
            </Box>
        </Modal>
    )
}
